import { useAuthStore } from '@/stores/auth.js'

export const permissionDirective = {
  mounted(el, binding) {
    checkPermission(el, binding)
  },

  updated(el, binding) {
    checkPermission(el, binding)
  }
}

function checkPermission(el, binding) {
  const authStore = useAuthStore()
  const { value } = binding

  let hasPermission = true

  if (!value) {
    return
  }

  // 处理不同类型的指令值
  let config

  if (typeof value === 'string') {
    // v-permission="'manage_market'"
    config = { permissions: [value] }
  } else if (Array.isArray(value)) {
    // v-permission="['manage_market', 'view_admin_panel']"
    config = { permissions: value }
  } else {
    // v-permission="{ permissions: ['manage_market'], roles: ['ADMIN'] }"
    config = value
  }

  const {
    permissions = [],
    roles = [],
    requireAuth = false,
    mode = 'all'
  } = config

  // 检查是否需要认证
  if (requireAuth && !authStore.isAuthenticated) {
    hasPermission = false
  }

  // 检查角色权限
  if (roles.length > 0 && authStore.user) {
    const userRole = authStore.user.role_code
    if (!roles.includes(userRole)) {
      hasPermission = false
    }
  }

  // 检查具体权限
  if (permissions.length > 0 && authStore.user) {
    const userRole = authStore.user.role_code

    if (mode === 'all') {
      // 需要所有权限
      hasPermission = permissions.every(permission =>
        authStore.hasPermission(permission)
      )
    } else {
      // 需要任一权限
      hasPermission = permissions.some(permission =>
        authStore.hasPermission(permission)
      )
    }
  }

  // 根据权限结果显示/隐藏元素
  if (hasPermission) {
    el.style.display = ''
  } else {
    el.style.display = 'none'
  }
}

// 安装指令的函数
export function setupPermissionDirective(app) {
  app.directive('permission', permissionDirective)
}

export default permissionDirective
